var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBloodSugarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#3A2CA0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25837_223938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7874 12.6289C24.7809 12.6222 24.7743 12.6156 24.7676 12.6091L19.3838 7.22533C19.0868 6.9301 18.6071 6.9301 18.3101 7.22533L10.7713 14.7642C10.646 14.8887 10.568 15.0529 10.5504 15.2287L10.0098 18.9981L13.0557 22.0441L16.8252 21.5034C16.9892 21.4814 17.1415 21.4065 17.2592 21.2902L24.7676 13.7057C25.0704 13.4138 25.0793 12.9318 24.7874 12.6289ZM14 19.0362L12.9187 17.9929L13.9924 16.9192L15.0661 17.9929L14 19.0362ZM15.6144 17.4218L14.5407 16.3481L15.6144 15.2744L16.6881 16.3481L15.6144 17.4218ZM20.9982 14.2311V14.193L18.8432 16.348C18.5461 16.6433 18.0665 16.6433 17.7694 16.348L15.6144 14.2311C15.3192 13.934 15.3192 13.4544 15.6144 13.1573L17.7694 11.0023C18.0665 10.7071 18.5461 10.7071 18.8432 11.0023L20.9982 13.1573C21.2935 13.4544 21.2935 13.9341 20.9982 14.2311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.60815 20.148C8.31291 20.4451 8.31291 20.9247 8.60815 21.2217L10.7632 23.3768C11.0602 23.672 11.5399 23.672 11.8369 23.3768L12.5984 22.6153L9.38484 19.3789L8.60815 20.148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99925 23.9192L8.07617 24.9961L9.63233 23.44L8.55541 22.363L6.99925 23.9192Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25837_223938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodSugarIcon);
export default __webpack_public_path__ + "static/media/blood-sugar-icon.b7eb55c602e2c18c71a429c887af57f2.svg";
export { ForwardRef as ReactComponent };